<template>	
	<div>
			<div class="mfty-box">
				<div class="row ju-c al-c" style="color: #000;font-size: 32px;font-weight: bold;">
					Lark-WMS企业仓库执行系统
				</div>
				<div class="row ju-c al-c" style="margin-top: 20px;">
					<div class="item-no" style="width: 120px;height: 2px;background-color: #0febe7;"></div>
				</div>
				<div style="width: 1200px;margin: 0 auto;margin-top: 50px;">
					<div class="row" style="justify-content: space-between;">
						<img src="../../assets/img/WESImg.png" />
						<div class="col" style="margin-left: 25px;justify-content: flex-start;">
							<div class="item-no" style="font-size: 24px;color: #000;">
								什么是Lark-WMS企业仓库执行系统?
							</div>
							<div class="item-no" style="font-size: 16px;color: #696969;margin-top: 20px;line-height: 29px;text-align: left;">
								WMS系统即仓库执行系统，Lark-WMS系统全称叫贸宝企业仓库执行系统，是通过入库业务、出库业务、仓库调拨、库存调拨和虚仓管理等功能，对批次管理、物料对应、库存盘点、质检管理、虚仓管理和即时库存管理等功能综合运用的管理系统，有效控制并跟踪仓库业务的物流和成本管理全过程，实现或完善的企业仓储信息管理。
							</div>
							<div class="item-no" style="font-size: 16px;color: #0070FD;margin-top: 15px;">
								<span style="font-size: 10px;margin-right: 2px;color: #0070FD;">●</span> 建立企业物流面的数据链 
							</div>
							<div class="item-no" style="font-size: 16px;color: #0070FD;margin-top: 15px;">
								<span style="font-size: 10px;margin-right: 2px;color: #0070FD;">●</span> 实现物料、产品的条码标识精细化管理以及跟踪 
							</div>
							<div class="item-no" style="font-size: 16px;color: #0070FD;margin-top: 15px;">
								<span style="font-size: 10px;margin-right: 2px;color: #0070FD;">●</span> 实现FIFO，快速上架下架以及实时库存管理 
							</div>
							<div class="item-no" style="font-size: 16px;color: #0070FD;margin-top: 15px;">
								<span style="font-size: 10px;margin-right: 2px;color: #0070FD;">●</span> 提供供应商远程客户端 
							</div>
						</div>
					</div>
				</div>
				
			</div>
			
			<div class="mfty-box" style="background-color: #f3f3f3;height: 700px;">
				<div class="row ju-c al-c" style="color: #000;font-size: 32px;font-weight: bold;">
					车间管理常见问题
				</div>
				<div class="row ju-c al-c" style="margin-top: 20px;">
					<div class="item-no" style="width: 120px;height: 2px;background-color: #0febe7;"></div>
				</div>
				<div style="width: 1200px;margin: 0 auto;margin-top: 50px;">
					<div class="row">
						<div class="col al-c">
							<img src="../../assets/img/WESicon1.png" />
							<div class="item ju-c" style="margin-top: 15px;">
								供应链管理乱
							</div>
							<div class="item ju-c" style="margin-top: 7px;">
								条码不同，编码规范混乱，管理困难
							</div>
						</div>
						<div class="col al-c">
							<img src="../../assets/img/WESicon2.png" />
							<div class="item ju-c" style="margin-top: 15px;">
								作业效率低
							</div>
							<div class="item ju-c" style="margin-top: 7px;">
								找料难，效率低，退料难，无单退料
							</div>
						</div>
						<div class="col al-c">
							<img src="../../assets/img/WESicon3.png" />
							<div class="item ju-c" style="margin-top: 15px;">
								准确率低
							</div>
							<div class="item ju-c" style="margin-top: 7px;">
								出入库容易出错，库存准确性不高
							</div>
						</div>
					</div>
					<div class="row" style="margin-top: 60px;">
						<div class="col al-c">
							<img src="../../assets/img/WESicon4.png" />
							<div class="item ju-c" style="margin-top: 15px;">
								批次管理难
							</div>
							<div class="item ju-c" style="margin-top: 7px;">
								先进先出难执行，呆滞品多
							</div>
						</div>
						<div class="col al-c">
							<img src="../../assets/img/WESicon5.png" />
							<div class="item ju-c" style="margin-top: 15px;">
								部门间协同困难
							</div>
							<div class="item ju-c" style="margin-top: 7px;">
								数据不及时不一致，对账难
							</div>
						</div>
						<div class="col al-c">
							<img src="../../assets/img/WESicon6.png" />
							<div class="item ju-c" style="margin-top: 15px;">
								现场管理混乱
							</div>
							<div class="item ju-c" style="margin-top: 7px;">
								流程不规范，容积率低，空间浪费大
							</div>
						</div>
					</div>
				</div>
			</div>
			
			<div class="mfty-box" style="height: 750px;">
				<div class="row ju-c al-c" style="color: #000;font-size: 32px;font-weight: bold;">
					Lark-WMS系统核心功能
				</div>
				<div class="row ju-c al-c" style="margin-top: 20px;">
					<div class="item-no" style="width: 120px;height: 2px;background-color: #0febe7;"></div>
				</div>
				<div style="width: 1200px;margin: 0 auto;margin-top: 80px;position: relative;">
					<el-carousel height="300px" indicator-position="outside" >
					    <el-carousel-item>
					     <div class="row ju-c">
					     	<div class="col-no al-c" style="height: 300px;background-color:#eee;width: 175px;">
					     		<div class="row ju-c al-c" style="height: 60px;color: #fff;font-size: 20px;font-weight: bold;background-color: #45cbdb;">
					     			库位管理
					     		</div>
					     		<div class="item-no ju-c al-c" style="color:#45cbdb;font-size:36px;border-bottom: 1px solid #45cbdb;width: 120px;height: 100px;">
					     			01
					     		</div>
					     		<div class="item-no" style="width: 120px;line-height: 24px;margin-top: 30px;">
					     			提供库位管理，实现库位与仓库，库位与产品的关联
					     		</div>
					     	</div>
					     	<div class="col-no al-c" style="margin-left: 30px;height: 300px;background-color:#eee;width: 175px;">
					     		<div class="row ju-c al-c" style="height: 60px;color: #fff;font-size: 20px;font-weight: bold;background-color: #20d29f;">
					     			入库管理
					     		</div>
					     		<div class="item-no ju-c al-c" style="color:#20d29f;font-size:36px;border-bottom: 1px solid #20d29f;width: 120px;height: 100px;">
					     			02
					     		</div>
					     		<div class="item-no" style="width: 120px;line-height: 24px;margin-top: 30px;">
					     			快速生成条码标签，自动提示上架库位
					     		</div>
					     	</div>
					     	<div class="col-no al-c" style="margin-left: 30px;height: 300px;background-color:#eee;width: 175px;">
					     		<div class="row ju-c al-c" style="height: 60px;color: #fff;font-size: 20px;font-weight: bold;background-color: #6f7af5;">
					     			出库管理
					     		</div>
					     		<div class="item-no ju-c al-c" style="color:#6f7af5;font-size:36px;border-bottom: 1px solid #6f7af5;width: 120px;height: 100px;">
					     			03
					     		</div>
					     		<div class="item-no" style="width: 120px;line-height: 24px;margin-top: 30px;">
					     			支持多种拣货策略，实现最短拣货路径
					     		</div>
					     	</div>
					     	<div class="col-no al-c" style="margin-left: 30px;height: 300px;background-color:#eee;width: 175px;">
					     		<div class="row ju-c al-c" style="height: 60px;color: #fff;font-size: 20px;font-weight: bold;background-color: #30bdff;">
					     			物料质检
					     		</div>
					     		<div class="item-no ju-c al-c" style="color:#30bdff;font-size:36px;border-bottom: 1px solid #30bdff;width: 120px;height: 100px;">
					     			04
					     		</div>
					     		<div class="item-no" style="width: 120px;line-height: 24px;margin-top: 30px;">
					     			与IQC检验设备实现对接，自动获取IQC检查结果
					     		</div>
					     	</div>
					     	
					     	<div class="col-no al-c" style="margin-left: 30px;height: 300px;background-color:#eee;width: 175px;">
					     		<div class="row ju-c al-c" style="height: 60px;color: #fff;font-size: 20px;font-weight: bold;background-color: #ff6541;">
					     			补货管理
					     		</div>
					     		<div class="item-no ju-c al-c" style="color:#ff6541;font-size:36px;border-bottom: 1px solid #ff6541;width: 120px;height: 100px;">
					     			05
					     		</div>
					     		<div class="item-no" style="width: 120px;line-height: 24px;margin-top: 30px;">
					     			根据库存预警自动提醒补货，支持紧急人工补货减少拣货等待
					     		</div>
					     	</div>
					     </div>
					    </el-carousel-item>
					    <el-carousel-item>
					     <div class="row ju-c">
					     	<div class="col-no al-c" style="height: 300px;background-color:#eee;width: 175px;">
					     		<div class="row ju-c al-c" style="height: 60px;color: #fff;font-size: 20px;font-weight: bold;background-color: #45cbdb;">
					     			备货下架
					     		</div>
					     		<div class="item-no ju-c al-c" style="color:#45cbdb;font-size:36px;border-bottom: 1px solid #45cbdb;width: 120px;height: 100px;">
					     			06
					     		</div>
					     		<div class="item-no" style="width: 120px;line-height: 24px;margin-top: 30px;">
					     			提供备料齐套检查，依据先进先出提供备料清单
					     		</div>
					     	</div>
					     	<div class="col-no al-c" style="margin-left: 30px;height: 300px;background-color:#eee;width: 175px;">
					     		<div class="row ju-c al-c" style="height: 60px;color: #fff;font-size: 20px;font-weight: bold;background-color: #20d29f;">
					     			条码管理
					     		</div>
					     		<div class="item-no ju-c al-c" style="color:#20d29f;font-size:36px;border-bottom: 1px solid #20d29f;width: 120px;height: 100px;">
					     			07
					     		</div>
					     		<div class="item-no" style="width: 120px;line-height: 24px;margin-top: 30px;">
					     			全程条码化管理，支持条码、二维码、RFID、电子标签
					     		</div>
					     	</div>
					     	<div class="col-no al-c" style="margin-left: 30px;height: 300px;background-color:#eee;width: 175px;">
					     		<div class="row ju-c al-c" style="height: 60px;color: #fff;font-size: 20px;font-weight: bold;background-color: #6f7af5;">
					     			AGV集成
					     		</div>
					     		<div class="item-no ju-c al-c" style="color:#6f7af5;font-size:36px;border-bottom: 1px solid #6f7af5;width: 120px;height: 100px;">
					     			08
					     		</div>
					     		<div class="item-no" style="width: 120px;line-height: 24px;margin-top: 30px;">
					     			通过集成和调度AGV，实现无人化的货物移动，提高仓储作业效率
					     		</div>
					     	</div>
					     	<div class="col-no al-c" style="margin-left: 30px;height: 300px;background-color:#eee;width: 175px;">
					     		<div class="row ju-c al-c" style="height: 60px;color: #fff;font-size: 20px;font-weight: bold;background-color: #30bdff;">
					     			看板管理
					     		</div>
					     		<div class="item-no ju-c al-c" style="color:#30bdff;font-size:36px;border-bottom: 1px solid #30bdff;width: 120px;height: 100px;">
					     			09
					     		</div>
					     		<div class="item-no" style="width: 120px;line-height: 24px;margin-top: 30px;">
					     			实时展示人员绩效、单据拣货进度以及异常情况等
					     		</div>
					     	</div>
					     	
					     	<div class="col-no al-c" style="margin-left: 30px;height: 300px;background-color:#eee;width: 175px;">
					     		<div class="row ju-c al-c" style="height: 60px;color: #fff;font-size: 20px;font-weight: bold;background-color: #ff6541;">
					     			盘点管理
					     		</div>
					     		<div class="item-no ju-c al-c" style="color:#ff6541;font-size:36px;border-bottom: 1px solid #ff6541;width: 120px;height: 100px;">
					     			10
					     		</div>
					     		<div class="item-no" style="width: 120px;line-height: 24px;margin-top: 30px;">
					     			自动生成仓库各类报表，并以数据化呈现，方便盘点
					     		</div>
					     	</div>
					     </div>
					    </el-carousel-item>
					    
					</el-carousel>
					
								
					<!-- <div class="row ju-c" style="margin-top: 40px;">
						<div class="item-no point"></div>
					</div> -->
				</div>
			</div>
		</div>
</template>

<script>
	export default {
		name: "App",
		data() {
			return {
				curHeight: 0,
				index: 1
			};
		},
		watch: {
			windowHeight(val) {
				let that = this;
				console.log("实时屏幕高度：", val, that.windowHeight);
			},
		},
		beforeMount() {

			var h = document.documentElement.clientHeight || document.body.clientHeight;

			this.curHeight = h; //减去页面上固定高度height

		},
		methods: {
			
		},
		mounted() {
			var that = this;
			window.onresize = () => {
				return (() => {
					window.fullHeight = document.documentElement.clientHeight;
					that.curHeight = window.fullHeight; // 高

				})()
			};
		},
	};
</script>
<style scoped>


	.center-body {
		margin: 0 auto;
	}
	.mfty-box{
		height: 600px;
		background-color: #fff;
		padding-top: 60px;
		text-align: center;
	}

	.fixed-bottom {
		position: fixed;
		bottom: 0;
	}

	.centerbtn {
		width: 240px;
		border-radius: 25px;
		background-color: #ff7e00;
		height: 50px;
		color: #fff;
		font-size: 20px;
		font-weight: bold;
		cursor: pointer;
	}

	.com {
		font-size: 18px;
		color: #aaaaaa;
	}

	.active {
		color: #0070FD;
	}
	/deep/.el-carousel__indicators--outside{
		padding-top: 25px;
	}
</style>
